import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this.isOpen = false
  }

  toggle() {
    this.isOpen = !this.isOpen
    this.updateMenu()
  }

  close() {
    this.isOpen = false
    this.updateMenu()
  }

  closeOnOutsideClick(event) {
    if (this.isOpen && !this.menuTarget.contains(event.target)) {
      const toggleButton = event.target.closest('[data-action*="sidebar#toggle"]')
      if (!toggleButton) {
        this.close()
      }
    }
  }

  updateMenu() {
    if (this.isOpen) {
      this.menuTarget.classList.remove("-translate-x-full")
    } else {
      this.menuTarget.classList.add("-translate-x-full")
    }
  }
}
